import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CourseSectionService } from '../../services/course-section.service'; // adjust path if needed
import { ToastService } from 'src/app/core/toast.service';
import { Router } from '@angular/router';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { DatePipe, formatDate } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/core/services/login.service';
import { MapsAPILoader } from '@agm/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { CourseListingComponent } from '../course-listing/course-listing.component';
import { LearningHubDetailsComponent } from 'src/app/modules/learning-hub/pages/learning-hub-details/learning-hub-details.component';
import { CourseDetailsPreviewComponent } from '../course-details-preview/course-details-preview.component';
import { TABLE_FIELDS, Tables } from 'src/app/shared/enum/tables.enum';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-course-post',
  templateUrl: './course-post.component.html',
  styleUrls: ['./course-post.component.scss'],
})

export class CoursePostComponent implements OnInit {

  coursePostForm: FormGroup;
  courseId: string | null = null;
  showCourseDate = false;
  courseTypeData: any[] = [];
  courseCategoryData: any[] = [];
  allCoursesData: any[] = [];
  isMultipleDayEvent = false;
  loginDetails: any;
  showWebinarLink = false;
  showEventType = false;
  autoLockedEventType = false;
  lockedEventTypeValue: string | null = null;
  // @ViewChild('addressSearch') addressSearchElementRef!: ElementRef;
  // private geoCoder;


  @ViewChild('addressSearch', { static: false }) addressSearchElementRef!: ElementRef;
  private geoCoder: google.maps.Geocoder;
  autocompleteInitialized = false;

  showAddressField: boolean = false;
  // isRsvpRequired = true;
  myCourse: any;
  userData:any;
  minStartTime: string = '';

  constructor(
    private _fb: FormBuilder,
    private toast: ToastService,
    private CourseSectionService: CourseSectionService,
    private router: Router,
    private mediaService: MediaService,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private CommonService:CommonServicesForAllModules
  ) { }

  ngOnInit(): void {


    this.loginDetails = this.loginService.getLoginData()

 

    this.coursePostForm = this._fb.group({
      course_name: ['', Validators.required],
      type: ['', Validators.required],
      course_category_id: [null, Validators.required],
      startDate: [{ value: '', disabled: true }, Validators.required],
      rsvp_date: [''],
      endDate: [{ value: '', disabled: true }, Validators.required],
      // presented_by_name: ['', Validators.required],
      // presented_by_image: [null, Validators.required],
      description: ['', Validators.required],
      address: [{ value: '', disabled: true },Validators.required],
      early_bird_price: [null, [Validators.min(0)]],
      afterwards_price: ['', [Validators.required]],
      number_of_seats: ['', [Validators.required]],
      cpd_points: ['', [Validators.required]],
      early_bird_end_date: ['',],
      topics_included: [''],
      learning_objectives: [''],
      event_type: ['', Validators.required],
      course_event_info: this._fb.array([this.createEventDayGroup()]),
      sponsor_by_image: [[]],
      course_gallery: [[], Validators.required],
      course_banner_video: [[]],
      course_banner_image: [[], Validators.required],
      terms: [''],
      refund_policy: [''],
      contact_name: ['', Validators.required],
      contact_email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      contact_phone: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      contact_website: ['', [Validators.required, Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/)]],
      register_link: ['', [Validators.required, Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/)]],
      instagram_link: ['', [ Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/)]],
      youtube_link: ['', [ Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/)]],
      facebook_link: ['', [ Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/)]],
      linkedin_link: ['', [ Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/)]],
      // webinar_link: ['', [Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/)]],
      webinar_link: [{ value: '', disabled: true }, Validators.required],
       community_user_type: [null],
      community_id: null,
      community_status: null,

      // startTime: ['', Validators.required],
       startTime: ['', [Validators.required, this.validateStartTime.bind(this)]],
      endTime: ['', Validators.required],
       presenters: this._fb.array([this.createPresenterGroup()])
    },
    );

  this.coursePostForm.get('startDate')?.valueChanges.subscribe((date) => {
    this.updateMinStartTime(date);
    this.coursePostForm.get('startTime')?.updateValueAndValidity(); // revalidate
  });

    this.coursePostForm.get('early_bird_end_date')?.valueChanges.subscribe(() => {
      this.checkAndDisableEarlyBirdPrice();
    });


    this.handleCourseFormatChange();
    this.monitorEventTypeChanges();
    // this.checkAndDisableEarlyBirdPrice();
    this.setupEarlyBirdEndDateValidation();
    this.setupAddressFieldLogic();
    this.listenEventTypeChanges();
    // this.listenEventTypeChanges()
    this.setupEarlyBirdPriceValidation()
    this.setupTimeRangeValidation()
    this.setupEarlyBirdWatcher();
     this.setupEventTypeFromDates();

    this.courseId = this.route.snapshot.paramMap.get('id');

    if (this.courseId) {
      this.fetchAndPatchCourse(this.courseId);
    }

    this.CourseSectionService.getCourseType().subscribe(data => {
      this.courseTypeData = data;

    });

    this.CourseSectionService.getCourseCategories().subscribe(data => {
      this.courseCategoryData = data;
    });

    this.CourseSectionService.getSupplierDataInfo(this.loginDetails.id).subscribe(data => {
      this.userData = data;
      this.toggleCommunityUserTypeValidator();
      console.log('userData',this.userData)
    });

      //  this.catalogueService.getSupplierDataInfo(this.token.id).subscribe(data => {
      // this.userData = data


    // start date end date  clear process
    const startCtrl = this.coursePostForm.get('startDate');
    const endCtrl = this.coursePostForm.get('endDate');
    // const rsvpCtrl = this.coursePostForm.get('rsvp_date');
    const earlyBidCtrl = this.coursePostForm.get('early_bird_end_date');

    // remove validation rsvp date 
    // startCtrl?.valueChanges.subscribe((startDate: Date) => {
    //   if (!startDate) return;

    //   const today = new Date();
    //   today.setHours(0, 0, 0, 0);

    //   const start = new Date(startDate);
    //   start.setHours(0, 0, 0, 0);

    //   if (start.getTime() === today.getTime()) {
    //     rsvpCtrl?.clearValidators();
    //     this.isRsvpRequired = false;
    //   } else {
    //     rsvpCtrl?.setValidators(Validators.required);
    //     this.isRsvpRequired = true;
    //   }

    //   rsvpCtrl?.updateValueAndValidity();
    // });


    if (startCtrl && endCtrl) {
      startCtrl.valueChanges.subscribe(startDate => {

        const endDate = new Date(endCtrl.value);

        if (endDate && startDate && startDate > endDate) {
          endCtrl.setValue(null); // clear end date
        }
      });
    }

    // if (startCtrl && rsvpCtrl) {
    //   startCtrl.valueChanges.subscribe(startDate => {

    //     const rsvpDate = new Date(rsvpCtrl.value);

    //     if (rsvpDate && startDate && startDate <= rsvpDate) {
    //       rsvpCtrl.setValue(null); // clear rsvp date
    //     }
    //   });
    // }

    if (startCtrl && earlyBidCtrl) {
      startCtrl.valueChanges.subscribe(startDate => {

        const earlyBidDate = new Date(earlyBidCtrl.value);

        if (earlyBidDate && startDate && startDate <= earlyBidDate) {
          earlyBidCtrl.setValue(null); // clear rsvp date
        }
      });
    }


  }

  private setupEventTypeFromDates(): void {
    const startCtrl = this.coursePostForm.get('startDate');
    const endCtrl = this.coursePostForm.get('endDate');
    const eventTypeCtrl = this.coursePostForm.get('event_type');

    if (!startCtrl || !eventTypeCtrl) return;

    const sameDay = (a: any, b: any) => {
      if (!a || !b) return false;
      const d1 = new Date(a);
      const d2 = new Date(b);
      return d1.getFullYear() === d2.getFullYear()
        && d1.getMonth() === d2.getMonth()
        && d1.getDate() === d2.getDate();
    };

    // watch user's manual changes to unlock if they explicitly change the value
    eventTypeCtrl.valueChanges.subscribe((val) => {
      if (this.autoLockedEventType) {
        // if user tries to change (control becomes dirty/touched and value differs) -> unlock
        if ((eventTypeCtrl.dirty || eventTypeCtrl.touched) && val !== this.lockedEventTypeValue) {
          this.autoLockedEventType = false;
          this.lockedEventTypeValue = null;
        }
      }
    });

    const update = () => {
      const startVal = startCtrl.value;
      const endVal = endCtrl?.value;

      if (!startVal) {
        if (eventTypeCtrl.pristine) {
          eventTypeCtrl.setValue('');
          this.autoLockedEventType = false;
          this.lockedEventTypeValue = null;
        }
        return;
      }

      const newType = !endVal || sameDay(startVal, endVal) ? 'single' : 'multiple';

      // Auto-set and lock only when control hasn't been modified by user
      if (eventTypeCtrl.pristine || (!eventTypeCtrl.dirty && !eventTypeCtrl.touched)) {
        eventTypeCtrl.setValue(newType);
        // lock the other option (hide/disable) until user manually changes
        this.autoLockedEventType = true;
        this.lockedEventTypeValue = newType;
      } else {
        // if user already changed, do not override — but if their selection matches newType, keep lock cleared
        if (eventTypeCtrl.value === newType) {
          // keep unlocked because user intentionally selected it
          this.autoLockedEventType = false;
          this.lockedEventTypeValue = null;
        }
      }
    };

    startCtrl.valueChanges.subscribe(() => update());
    endCtrl?.valueChanges.subscribe(() => update());
    update();
  }

  // helper used in template to disable/hide the opposite option when locked
  isEventTypeOptionDisabled(option: string): boolean {
    if (!this.autoLockedEventType) return false;
    return option !== this.lockedEventTypeValue;
  }



updateMinStartTime(selectedDate: any) {
  const today = new Date();

  if (!selectedDate) {
    this.minStartTime = '';
    return;
  }

  // Always convert Angular datepicker value to real Date
  const selected = new Date(selectedDate instanceof Date ? selectedDate : new Date(selectedDate));

  if (isNaN(selected.getTime())) {
    this.minStartTime = '';
    return;
  }

  const isToday =
    selected.getFullYear() === today.getFullYear() &&
    selected.getMonth() === today.getMonth() &&
    selected.getDate() === today.getDate();

  if (isToday) {
    const hh = today.getHours().toString().padStart(2, '0');
    const mm = today.getMinutes().toString().padStart(2, '0');
    this.minStartTime = `${hh}:${mm}`;  // always 24-hour
  } else {
    this.minStartTime = '';
  }
}

validateStartTime(control: FormControl) {
  const time = control.value;
  if (!time) return null;

  const date = this.coursePostForm.get('startDate')?.value;
  if (!date) return null;

  const selectedDate = new Date(date);
  const today = new Date();

  const isToday =
    selectedDate.getFullYear() === today.getFullYear() &&
    selectedDate.getMonth() === today.getMonth() &&
    selectedDate.getDate() === today.getDate();

  if (!isToday) return null;

  // Convert HH:mm to number
  const [hh, mm] = time.split(':').map(Number);

  const selectedMinutes = hh * 60 + mm;
  const currentMinutes = today.getHours() * 60 + today.getMinutes();

  return selectedMinutes < currentMinutes
    ? { timeTooEarly: true }
    : null;
}



    ngOnChanges() {
    this.toggleCommunityUserTypeValidator();
  }
  
  ngAfterViewInit() {
    this.toggleCommunityUserTypeValidator();
  }
  
  
    private toggleCommunityUserTypeValidator(): void {
    const control = this.coursePostForm.get('community_user_type');
  
    if (this.userData?.community_status === 'YES' && this.userData?.community_id) {
      control.setValidators([Validators.required]);
    } else {
      control.clearValidators();
      control.setValue(null); // optional - reset value if hidden
    }
  
    control.updateValueAndValidity();
  }


    get presenters(): FormArray {
    return this.coursePostForm.get('presenters') as FormArray;
  }
  createPresenterGroup(): FormGroup {
    return this._fb.group({
      presented_by_name: [null, Validators.required],
      presented_by_image: [null, Validators.required],
      presenterImageUrl: [null]
    });
  }

  addPresenter() {
      if (this.presenters.length >= 12) {
    this.toast.openSnackBar('You can only add up to 12 presenters');
    return;
  }
    this.presenters.push(this.createPresenterGroup());
  }

  removePresenter(index: number) {
    this.presenters.removeAt(index);
  }
  // Update presenter image handling
  uploadPresenterImage(event: Event, index: number): void {
    const file = (event.target as HTMLInputElement)?.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    this.mediaService.uploadMedia(formData).subscribe({
      next: (res: any) => {
        const imageData = {
          url: res.url,
          name: file.name,
          type: file.type,
          size: file.size
        };

        // Update the specific presenter's image
        const presenter = this.presenters.at(index);
        presenter.patchValue({
          presented_by_image: imageData,
          presenterImageUrl: res.url
        });
        presenter.markAsDirty();
      },
      error: () => {
        this.toast.openSnackBar('Presenter image upload failed');
      }
    });
  }

  removePresenterImage(index: number): void {
    const presenter = this.presenters.at(index);
    presenter.patchValue({
      presented_by_image: null,
      presenterImageUrl: null
    });
    presenter.markAsTouched();
  }


  ngAfterViewChecked(): void {
    if (this.showAddressField && !this.autocompleteInitialized && this.addressSearchElementRef) {
      this.initGoogleAutocomplete();
      this.autocompleteInitialized = true;
    }
  }

  private initGoogleAutocomplete(): void {
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.addressSearchElementRef.nativeElement, {
        componentRestrictions: { country: 'AU' },
        fields: ['address_components', 'formatted_address', 'geometry']
      });

      this.geoCoder = new google.maps.Geocoder();

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();

          if (place.formatted_address) {
            this.coursePostForm.get('address')?.setValue(place.formatted_address);
          }

          const components = place.address_components;
          const state = components?.find(c => c.types.includes('administrative_area_level_1'))?.long_name;

        });
      });
    });
  }



  createEventDayGroup(): FormGroup {
    return this._fb.group({
      name: ['', Validators.required],
      info: ['', Validators.required],
      date: [null, Validators.required],
      images: [[], Validators.required]
    });
  }

  get eventDaysForm(): FormArray {
    return this.coursePostForm.get('course_event_info') as FormArray;
  }
  /** Toggle validators based on event_type */
  private listenEventTypeChanges(): void {
    const eventTypeCtrl = this.coursePostForm.get('event_type');

    eventTypeCtrl?.valueChanges.subscribe((type: string) => {
      const eventDays = this.coursePostForm.get('course_event_info') as FormArray;

      eventDays.controls.forEach((day: FormGroup) => {
        if (type === 'single') {
          //  remove validators for single-day event
          ['name', 'info', 'images'].forEach(ctrl => {
            day.get(ctrl)?.clearValidators();
            day.get(ctrl)?.updateValueAndValidity();
          });
        } else {
          //  add validators back for multiple-day event
          ['name', 'info', 'images'].forEach(ctrl => {
            day.get(ctrl)?.setValidators(Validators.required);
            day.get(ctrl)?.updateValueAndValidity();
          });
        }

        // date is always required
        day.get('date')?.setValidators(Validators.required);
        day.get('date')?.updateValueAndValidity();
      });
    });

  }




  //   private resetFormGroupValues(group: FormGroup) {
  //   Object.keys(group.controls).forEach(key => {
  //     group.get(key)?.setValue(null);
  //     group.get(key)?.updateValueAndValidity({ onlySelf: true });
  //   });
  // }


  // private listenEventTypeChanges(): void {
  //   const eventTypeCtrl = this.coursePostForm.get('event_type');
  //   const eventDays = this.coursePostForm.get('course_event_info') as FormArray;

  //   eventTypeCtrl?.valueChanges.subscribe((type: string) => {

  //     // Reset only root-level fields
  //     ['learning_objectives', 'topics_included'].forEach(ctrlName => {
  //       this.coursePostForm.get(ctrlName)?.setValue(null);
  //       this.coursePostForm.get(ctrlName)?.updateValueAndValidity({ onlySelf: true });
  //     });

  //     // Reapply validators for eventDays (without clearing values)
  //     eventDays.controls.forEach((day: FormGroup) => {
  //       const fields = ['name', 'info', 'images'];
  //       fields.forEach(ctrl => {
  //         if (type === 'single') {
  //           day.get(ctrl)?.clearValidators();
  //         } else {
  //           day.get(ctrl)?.setValidators(Validators.required);
  //         }
  //         day.get(ctrl)?.updateValueAndValidity({ onlySelf: true });
  //       });

  //       // Date is always required
  //       day.get('date')?.setValidators(Validators.required);
  //       day.get('date')?.updateValueAndValidity({ onlySelf: true });
  //     });
  //   });
  // }



  fetchAndPatchCourse(courseId: string): void {
    // this.CourseSectionService.getCourseById(courseId).subscribe(course => {
    this.CommonService.GetById(Tables.Courses, courseId, TABLE_FIELDS.Courses).subscribe(course => {

      this.myCourse = course;  
      
            // Clear existing presenters array
      const presentersArray = this.coursePostForm.get('presenters') as FormArray;
      presentersArray.clear();


      // Add presenter form groups for each presenter in the data
      if (course.presenters && course.presenters.length > 0) {
        course.presenters.forEach((presenter: any) => {
          presentersArray.push(this._fb.group({
            presented_by_name: [presenter.presented_by_name, Validators.required],
            presented_by_image: [presenter.presented_by_image, Validators.required],
            presenterImageUrl: [presenter.presented_by_image?.url || null]
          }));
        });
      } else {
        // Add one empty presenter form if no presenters exist
        presentersArray.push(this.createPresenterGroup());
      }


      const formatTimeForInput = (time: string | null) => {
        if (!time) return null;
        // remove timezone if present
        const clean = time.split('+')[0];        // "18:11:00"
        // remove seconds if present
        const [hh, mm] = clean.split(':');       // ["18","11"]
        return `${hh}:${mm}`;                    // "18:11"
      };

      const startTimeForInput = formatTimeForInput(course.startTime);
      const endTimeForInput = formatTimeForInput(course.endTime);


      this.presenterImageUrl = course.presented_by_image?.url || '';
      this.coursePostForm.get('presented_by_image')?.setValue(course.presented_by_image || null);



      if (Array.isArray(course.sponsor_by_image)) {
        this.sponsorImages = [...course.sponsor_by_image];
      } else if (course.sponsor_by_image) {
        this.sponsorImages = [course.sponsor_by_image];
      } else {
        this.sponsorImages = [];
      }


      if (Array.isArray(course.course_gallery)) {
        this.galleryImages = [...course.course_gallery];
      } else if (course.course_gallery) {
        this.galleryImages = [course.course_gallery];
      } else {
        this.galleryImages = [];
      }




      if (Array.isArray(course.course_banner_video)) {
        this.courseBannerMedia = [...course.course_banner_video];
      } else if (course.course_banner_video) {
        this.courseBannerMedia = [course.course_banner_video];
      } else {
        this.courseBannerMedia = [];
      }

      if (Array.isArray(course.course_banner_image)) {
        this.courseBannerImage = [...course.course_banner_image];
      } else if (course.course_banner_image) {
        this.courseBannerImage = [course.course_banner_image];
      } else {
        this.courseBannerImage = [];
      }


      // Patch eventDays (stored as course_event_info in DB)
      
      if (Array.isArray(course.course_event_info) && course.course_event_info.length > 0) {
        const fa = this.eventDaysForm;
        fa.clear(); // remove old controls

        course.course_event_info.forEach((day: any) => {
          fa.push(
            this._fb.group({
              name: [day.name || '', Validators.required],
              info: [day.info || '', Validators.required],
              date: [
                this.myCourse?.status === 'EXPIRED' ? null : day.date || null,
                Validators.required,
              ],
              images: [day.images || [], Validators.required],
            })
          );
        });
      } else {
        this.eventDaysForm.clear();
        this.eventDaysForm.push(this.createEventDayGroup());
      }

      
      if (course.presenters && course.presenters.length > 0) {
        const presentersFormArray = this.coursePostForm.get('presenters') as FormArray;
        presentersFormArray.clear();

        course.presenters.forEach((p: any) => {
          presentersFormArray.push(this._fb.group({
            presented_by_name: [p.presented_by_name, Validators.required],
            presented_by_image: [p.presented_by_image, Validators.required],
            presenterImageUrl: [p.presenterImageUrl || (p.presented_by_image?.url || null)]
          }));
        });
      }


      if (course) {


        this.coursePostForm.patchValue({
          course_name: course.course_name,
          type: course.type,
          course_category_id: course.course_category_id,
          // startDate: course.startDate,
          // startTime: startTimeForInput,
          // endTime: endTimeForInput,
          // endDate: course.endDate,
          presented_by_name: course.presented_by_name,
          presented_by_image: this.presenterImageUrl,
          description: course.description,
          address: course.address,
          cpd_points: course.cpd_points,
          number_of_seats: course.number_of_seats,
          early_bird_price: course.early_bird_price,
          early_bird_end_date: course.early_bird_end_date,
          afterwards_price: course.afterwards_price,
          topics_included: course.topics_included,
          learning_objectives: course.learning_objectives,
          event_type: course.event_type,
          // course_event_info: course.course_event_info,
          sponsor_by_image: this.sponsorImages,
          course_gallery: this.galleryImages,
          course_banner_video: this.courseBannerMedia,
          course_banner_image: this.courseBannerImage,
          terms: course.terms,
          refund_policy: course.refund_policy,
          contact_name: course.contact_name,
          contact_email: course.contact_email,
          contact_phone: course.contact_phone,
          contact_website: course.contact_website,
          register_link: course.register_link,
          webinar_link: course.webinar_link,
         community_user_type: course.community_user_type,
          instagram_link: course.instagram_link,
          youtube_link: course.youtube_link,
          facebook_link: course.facebook_link,
          linkedin_link: course.linkedin_link,
          created_by_id: this.loginDetails.id,
          user_role: this.loginDetails.type,
          company_name: this.loginDetails.name,
          // rsvp_date: course.rsvp_date,

        });

        if (this.myCourse?.status !== 'EXPIRED') {
          this.coursePostForm.patchValue({
            startDate: this.myCourse?.startDate,
            startTime: startTimeForInput,
            endTime: endTimeForInput,
            endDate: this.myCourse?.endDate,
          });
        }





        //  Enable date fields conditionally
        const requiresDate = ['Webinar', 'Live Course', 'Event'].includes(course.type);
        if (requiresDate) {
          this.coursePostForm.get('startDate')?.enable();
          this.coursePostForm.get('endDate')?.enable();
        }
      }

    });
  }

  checkAndDisableEarlyBirdPrice(): void {
    const endDateControl = this.coursePostForm.get('early_bird_end_date');
    const priceControl = this.coursePostForm.get('early_bird_price');

    if (!endDateControl || !priceControl) return;

    const endDateValue = endDateControl.value;
    if (!endDateValue) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const endDate = new Date(endDateValue);
    endDate.setHours(0, 0, 0, 0);

    if (isNaN(endDate.getTime())) return;

    if (endDate < today) {
      priceControl.setValue(0);
      priceControl.disable();
      endDateControl.markAsTouched();
    } else {
      priceControl.enable();
    }
  }

  setupEarlyBirdEndDateValidation(): void {
    const earlyBirdPriceControl = this.coursePostForm.get('early_bird_price');
    const earlyBirdEndDateControl = this.coursePostForm.get('early_bird_end_date');

    if (!earlyBirdPriceControl || !earlyBirdEndDateControl) return;

    earlyBirdPriceControl.valueChanges.subscribe((priceValue) => {
      if (priceValue) {
        earlyBirdEndDateControl.setValidators([Validators.required]);
      } else {
        earlyBirdEndDateControl.clearValidators();
        earlyBirdEndDateControl.setValue(null);
      }

      earlyBirdEndDateControl.updateValueAndValidity();

      if (earlyBirdEndDateControl.invalid && earlyBirdEndDateControl.value === null) {
        earlyBirdEndDateControl.markAsTouched();
      }
    });
  }

  setupEarlyBirdPriceValidation(): void {
    const earlyBirdCtrl = this.coursePostForm.get('early_bird_price');
    const totalCtrl = this.coursePostForm.get('afterwards_price');

    if (!earlyBirdCtrl || !totalCtrl) return;

    // Re-validate early bird whenever either value changes
    const validate = () => {
      const early = +earlyBirdCtrl.value;
      const total = +totalCtrl.value;

      if (early && total && early >= total) {
        earlyBirdCtrl.setErrors({ lessThanTotal: true });
      } else {
        // keep any other errors (e.g. required) but remove ours
        if (earlyBirdCtrl.hasError('lessThanTotal')) {
          const errors = { ...earlyBirdCtrl.errors };
          delete errors['lessThanTotal'];
          earlyBirdCtrl.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    };

    earlyBirdCtrl.valueChanges.subscribe(validate);
    totalCtrl.valueChanges.subscribe(validate);
  }


  setupTimeRangeValidation(): void {
    const startCtrl = this.coursePostForm.get('startTime');
    const endCtrl = this.coursePostForm.get('endTime');

    if (!startCtrl || !endCtrl) return;

    const validate = () => {
      const start = startCtrl.value;
      const end = endCtrl.value;

      if (!start || !end) {
        // let required validators handle empties
        return;
      }

      const [sH, sM] = start.split(':').map(Number);
      const [eH, eM] = end.split(':').map(Number);
      const startMinutes = sH * 60 + sM;
      const endMinutes = eH * 60 + eM;

      if (endMinutes <= startMinutes) {
        endCtrl.setErrors({ endBeforeStart: true });
      } else {
        // remove only our custom error if present
        if (endCtrl.hasError('endBeforeStart')) {
          const errors = { ...endCtrl.errors };
          delete errors['endBeforeStart'];
          endCtrl.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    };

    // Re-validate whenever either time changes
    startCtrl.valueChanges.subscribe(validate);
    endCtrl.valueChanges.subscribe(validate);
  }



  handleCourseFormatChange(): void {
    this.coursePostForm.get('type')?.valueChanges.subscribe(value => {
      const noDateTypes = ['Online Academy'];
      const requiresDate = !noDateTypes.includes(value);

      const start = this.coursePostForm.get('startDate');
      const end = this.coursePostForm.get('endDate');
      const webinarLink = this.coursePostForm.get('webinar_link');
      const eventType = this.coursePostForm.get('event_type');
      const eventDays = this.eventDaysForm;

      this.showCourseDate = requiresDate;
      this.showWebinarLink = (value === 'Webinar');

      /** -------------------------
       * Handle Dates
       * ------------------------- */
      if (requiresDate) {
        start?.enable();
        end?.enable();
        start?.setValidators(Validators.required);
        end?.setValidators(Validators.required);
      } else {
        start?.disable();
        end?.disable();
        start?.clearValidators();
        end?.clearValidators();
        start?.setValue('');
        end?.setValue('');
      }
      start?.updateValueAndValidity();
      end?.updateValueAndValidity();

      /** -------------------------
       * Handle Webinar link
       * ------------------------- */
      if (value === 'Webinar') {
        webinarLink?.enable();
        webinarLink?.setValidators([
          Validators.required,
          Validators.pattern(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/)
        ]);
      } else {
        webinarLink?.disable();
        webinarLink?.clearValidators();
        webinarLink?.setValue('');
      }
      webinarLink?.updateValueAndValidity();

      /** -------------------------
       * Handle Event Type & Event Days
       * ------------------------- */
      if (value === 'Webinar') {
        // Disable event_type
        eventType?.disable();
        eventType?.clearValidators();
        eventType?.setValue('');

        // Clear and disable event days
        eventDays.clear(); // remove all controls
        eventDays.disable();
      } else {
        // Enable event_type
        eventType?.enable();
        eventType?.setValidators(Validators.required);

        // Enable event days
        if (eventDays.length === 0) {
          eventDays.push(this.createEventDayGroup());
        }
        eventDays.enable();
      }

      eventType?.updateValueAndValidity();
      eventDays.updateValueAndValidity();
    });
  }

  /** Group-level validator */


  setupAddressFieldLogic(): void {
    const typeControl = this.coursePostForm.get('type');
    const addressControl = this.coursePostForm.get('address');

    if (!typeControl || !addressControl) return;

    const allowedTypes = ['Event', 'Live Course', 'Live Event'];

    const updateAddressVisibility = (typeValue: string) => {
      if (allowedTypes.includes(typeValue)) {
        this.showAddressField = true;
        addressControl.enable();
      } else {
        this.showAddressField = false;
        addressControl.disable();
        addressControl.setValue('');
      }
    };

    // Subscribe to future changes
    typeControl.valueChanges.subscribe(updateAddressVisibility);

    // Run once initially (in edit case)
    updateAddressVisibility(typeControl.value);
  }


  // Monitor changes to event type and update form state
  monitorEventTypeChanges(): void {
    const eventTypeControl = this.coursePostForm.get('event_type');

    if (eventTypeControl) {
      // Update immediately based on initial value
      this.isMultipleDayEvent = eventTypeControl.value === 'multiple';

      // Subscribe to future changes
      eventTypeControl.valueChanges.subscribe((type: string) => {
        this.isMultipleDayEvent = type === 'multiple';
      });
    }
  }




  async submitCourse(mode: 'publish' | 'draft' = 'publish', submitStatus:any): Promise<void> {
    
    if (mode === 'publish') {
      if (this.coursePostForm.invalid) {
        this.toast.openSnackBar('Please fill all required fields.');
        this.coursePostForm.markAllAsTouched();

        const invalidControls = Object.keys(this.coursePostForm.controls).filter(
          name => this.coursePostForm.get(name)?.invalid
        );
        return;
      }
    }

    const fullData = this.coursePostForm.getRawValue().course_event_info.map((day: any) => ({
      ...day,
      date: day.date ? formatDate(day.date, 'yyyy-MM-dd', 'en-US') : null
    }));


    const formValues = this.coursePostForm.getRawValue();

    
    // Format presenters data
    const formattedPresenters = formValues.presenters.map((presenter: any) => ({
      presented_by_name: presenter.presented_by_name,
      presented_by_image: this.normalizeMedia(presenter.presented_by_image)
    }));


    const formattedStartDate = formValues.startDate
      ? formatDate(formValues.startDate, 'yyyy-MM-dd', 'en-US')
      : null;
    const formattedEndDate = formValues.endDate
      ? formatDate(formValues.endDate, 'yyyy-MM-dd', 'en-US')
      : null;
    const formattedEarlyBirdEndDate = formValues.early_bird_end_date
      ? formatDate(formValues.early_bird_end_date, 'yyyy-MM-dd', 'en-US')
      : null;

    // const formattedRsvpDate = formValues.rsvp_date
    //   ? formatDate(formValues.rsvp_date, 'yyyy-MM-dd', 'en-US')
    //   : null;

    // const normalizeMedia = (media: any) => {
    //   if (!media) return null;
    //   if (Array.isArray(media)) {
    //     return media.map(m => (typeof m === 'string' ? { url: m } : m));
    //   }
    //   return typeof media === 'string' ? { url: media } : media;
    // };

    const rawStartTime = this.coursePostForm.value.startTime;

    let timeWithAmPmStart: string | null = null;

    if (rawStartTime) {
      timeWithAmPmStart = this.datePipe.transform(
        new Date(`1970-01-01T${rawStartTime}:00`),
        'hh:mm a'
      );
    }



    const rawEndTime = this.coursePostForm.value.endTime;
    let timeWithAmPmEnd: string | null = null;

    if (rawEndTime) {
      timeWithAmPmEnd = this.datePipe.transform(
        new Date(`1970-01-01T${rawEndTime}:00`),
        'hh:mm a'
      );
    }



    const courseData = {
      course_name: formValues.course_name,
      type: formValues.type,
      course_category_id: formValues.course_category_id,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      // presented_by_name: formValues.presented_by_name,
      // presented_by_image: formValues.presented_by_image,
      // presented_by_image: normalizeMedia(formValues.presented_by_image),
      presenters: formattedPresenters,

      description: formValues.description,
      address: formValues.address,
      cpd_points: formValues.cpd_points || null,
      number_of_seats: formValues.number_of_seats || null,
      early_bird_price: formValues.early_bird_price || null,
      early_bird_end_date: formattedEarlyBirdEndDate || null,
      afterwards_price: formValues.afterwards_price || null,
      topics_included: formValues.topics_included || null,
      learning_objectives: formValues.learning_objectives || null,
      event_type: formValues.event_type || null,
      course_event_info: fullData,
      sponsor_by_image: formValues.sponsor_by_image,
      course_gallery: formValues.course_gallery,
      course_banner_video: formValues.course_banner_video,
      course_banner_image: formValues.course_banner_image,
      terms: formValues.terms,
      refund_policy: formValues.refund_policy,
      contact_name: formValues.contact_name,
      contact_email: formValues.contact_email,
      contact_phone: formValues.contact_phone,
      contact_website: formValues.contact_website,
      register_link: formValues.register_link,
      instagram_link: formValues.instagram_link,
      youtube_link: formValues.youtube_link,
      community_user_type: formValues.community_user_type,
     community_id : this.userData?.community_id ?? null,
     community_status : this.userData?.community_status ?? null,
      facebook_link: formValues.facebook_link,
      linkedin_link: formValues.linkedin_link,
      webinar_link: formValues.webinar_link,
      startTime: timeWithAmPmStart || null,
      endTime: timeWithAmPmEnd || null,
      // rsvp_date: formattedRsvpDate,
      created_by_id: this.loginDetails.id,
      user_role: this.loginDetails.type,
      company_name: this.loginDetails.name,
      status:
        mode === 'publish'
          ? this.loginDetails?.type === 'ADMIN'
            ? 'APPROVE'
            : submitStatus
          : 'DRAFT',
      active_status: formValues.active_status,
    };


    try {
      let response;
      if (this.courseId  && this.myCourse.status !== 'EXPIRED') {
        response = await this.CommonService.UpdateData(Tables.Courses, this.courseId, courseData);
      } else {
        response = await this.CommonService.InsertData(Tables.Courses, courseData);
      }      

      if (response) {
        const msg = this.courseId && this.myCourse.status !== 'EXPIRED'
          ? (mode === 'publish' ? 'Course updated successfully' : 'Draft updated successfully')
          : (mode === 'publish' ? 'Course posted successfully' : 'Draft saved successfully');
        this.toast.openSnackBar(msg);
        this.router.navigate(['/profile/course-listing']);
      }
    } catch (error) {
      console.error('Error while posting course:', error);
      this.toast.openSnackBar('An error occurred while posting the course.');
    }
  }

  private normalizeMedia(media: any) {
    if (!media) return null;
    if (Array.isArray(media)) {
      return media.map(m => (typeof m === 'string' ? { url: m } : m));
    }
    return typeof media === 'string' ? { url: media } : media;
  }

  //  hide the early bird price and date
  isToday(date: Date | string): boolean {
    if (!date) return false;
    const d = new Date(date);
    const t = new Date();
    d.setHours(0, 0, 0, 0);
    t.setHours(0, 0, 0, 0);
    return d.getTime() === t.getTime();
  }

  // Clears early-bird price and end-date if startDate is today
  setupEarlyBirdWatcher(): void {
    const startDateCtrl = this.coursePostForm.get('startDate');
    const earlyBirdEndCtrl = this.coursePostForm.get('early_bird_end_date');
    const earlyBirdPriceCtrl = this.coursePostForm.get('early_bird_price');

    startDateCtrl?.valueChanges.subscribe((val: Date | string) => {
      const isTodayDate = this.isToday(val);

      if (isTodayDate) {
        // Clear value, remove any existing validators, disable
        earlyBirdEndCtrl?.setValue(null, { emitEvent: false });
        earlyBirdEndCtrl?.clearValidators();
        earlyBirdEndCtrl?.disable({ emitEvent: false });
        earlyBirdEndCtrl?.updateValueAndValidity({ emitEvent: false });

        earlyBirdPriceCtrl?.setValue(null, { emitEvent: false });
        earlyBirdPriceCtrl?.clearValidators();
        earlyBirdPriceCtrl?.disable({ emitEvent: false });
        earlyBirdPriceCtrl?.updateValueAndValidity({ emitEvent: false });
      } else {
        // Just re-enable (no validators restored)
        earlyBirdEndCtrl?.enable({ emitEvent: false });
        earlyBirdEndCtrl?.updateValueAndValidity({ emitEvent: false });

        earlyBirdPriceCtrl?.enable({ emitEvent: false });
        earlyBirdPriceCtrl?.updateValueAndValidity({ emitEvent: false });
      }
    });
  }




  onDatePicked(event: any, index: number): void {
    // event.value is a Date object
    const chosen = event.value as Date;

    // if you prefer a formatted string
    const formatted = chosen.toISOString().split('T')[0];
  }

  eventImageUrl: string | null = null;

  // course infprmation

  eventDays = [
    { name: '', info: '', date: null, images: [] }
  ];

  addEventDay(): void {
    const allValid = this.eventDaysForm.controls.every(group => group.valid);

    if (!allValid) {
      this.eventDaysForm.controls.forEach(group => {
        Object.values((group as FormGroup).controls).forEach(control => {
          control.markAsTouched();
        });
      });
      this.toast.openSnackBar('Please fill all event day details correctly before adding a new day.');
      return;
    }

    // If all are valid, add a new event day
    const newGroup = this.createEventDayGroup();
    this.eventDaysForm.push(newGroup);
  }

  removeEventDay(index: number): void {
    if (this.eventDaysForm.length > 1) {
      this.eventDaysForm.removeAt(index);
    }
  }
  uploadEventImage(event: Event, dayIndex: number): void {
    const input = event.target as HTMLInputElement;
    const files = input?.files;
    if (!files) return;

    const eventDayControl = this.eventDaysForm.at(dayIndex);
    if (!eventDayControl) return;

    Array.from(files).forEach(file => {
      const formData = new FormData();
      formData.append('file', file);

      this.mediaService.uploadMedia(formData).subscribe({
        next: (res: any) => {
          const currentImages = eventDayControl.get('images')?.value || [];

          const newImage = {
            url: res.url,
            name: file.name,
            type: file.type,
            size: file.size,
          };

          eventDayControl.get('images')?.setValue([...currentImages, newImage]);
          eventDayControl.get('images')?.markAsTouched();
        },
        error: () => {
          this.toast.openSnackBar('Image upload failed');
        }
      });
    });

    // ✅ Reset the input so the same file can be uploaded again if needed
    input.value = '';
  }


  removeEventImage(dayIndex: number, imgIndex: number): void {
    const eventDayControl = this.eventDaysForm.at(dayIndex);
    if (!eventDayControl) return;

    const originalImages = eventDayControl.get('images')?.value || [];

    // Clone the array to avoid modifying frozen arrays
    const updatedImages = [...originalImages];
    updatedImages.splice(imgIndex, 1);

    eventDayControl.get('images')?.setValue(updatedImages);
    eventDayControl.get('images')?.markAsTouched();
  }



  // Present by image logic

  presenterImageUrl: string | null = null;

  // uploadPresenterImage(event: Event): void {
  //   const file = (event.target as HTMLInputElement)?.files?.[0];
  //   if (!file) return;

  //   const formData = new FormData();
  //   formData.append('file', file);

  //   this.mediaService.uploadMedia(formData).subscribe({
  //     next: (res: any) => {
  //       const imageData = {
  //         url: res.url,
  //         name: file.name,
  //         type: file.type,
  //         size: file.size
  //       };

  //       this.presenterImageUrl = res.url;
  //       this.coursePostForm.get('presented_by_image')?.setValue(imageData);
  //     },
  //     error: () => {
  //       this.toast.openSnackBar('Image upload failed');
  //     }
  //   });
  // }

  // removePresenterImage(): void {
  //   this.presenterImageUrl = '';
  //   this.coursePostForm.get('presented_by_image')?.setValue(null);
  //   this.coursePostForm.get('presented_by_image')?.markAsTouched();

  //   //  Clear the file input as well (optional, if reused)
  //   const fileInput = document.getElementById('presenterFileInput') as HTMLInputElement;
  //   if (fileInput) {
  //     fileInput.value = ''; // this is the only allowed value
  //   }
  // }


  // Sponsor images logic

  sponsorImages: { url: string; name: string; type: string; size: number }[] = [];

  uploadSponsorImages(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const files = Array.from(input.files);
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);

      this.mediaService.uploadMedia(formData).subscribe({
        next: (res: any) => {
          const imageData = {
            url: res.url,
            name: file.name,
            type: file.type,
            size: file.size
          };

          // Add to local image preview list
          this.sponsorImages.push(imageData);

          // Update form control
          this.coursePostForm.get('sponsor_by_image')?.setValue(this.sponsorImages);
          this.coursePostForm.get('sponsor_by_image')?.markAsDirty();

          //  Clear the file input so same file can be reselected again
          input.value = '';
        },
        error: () => {
          this.toast.openSnackBar('Sponsor image upload failed');
        }
      });
    }
  }


  removeSponsorImage(index: number): void {
    // Clone the array to avoid mutating a frozen object
    const updatedImages = [...this.sponsorImages];

    updatedImages.splice(index, 1); // safely remove image

    this.sponsorImages = updatedImages;

    // Update form control
    this.coursePostForm.get('sponsor_by_image')?.setValue(this.sponsorImages);
    this.coursePostForm.get('sponsor_by_image')?.markAsDirty();
    this.coursePostForm.get('sponsor_by_image')?.markAsTouched();
  }

  // Course Banner video logic

  courseBannerMedia: { url: string; name: string; type: string; size: number }[] = [];

  uploadCourseBannerMedia(event: Event): void {

    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const files = Array.from(input.files);

    const existingType = this.courseBannerMedia.length
    ? (this.courseBannerMedia[0].type.startsWith("image/") ? "image" : "video")
    : null;

    for (const file of files) {

    const newType = file.type.startsWith("image/") ? "image" : "video";

    // Validation: Allow only same type as existing uploads
    if (existingType && existingType !== newType) {
      this.toast.openSnackBar(
        `Please upload only one type of media: images OR videos`
      );

    
      input.value = '';
      return;
    }
      const formData = new FormData();
      formData.append('file', file);

      this.mediaService.uploadMedia(formData).subscribe({
        next: (res: any) => {
          const fileData = {
            url: res.url,
            name: file.name,
            type: file.type,
            size: file.size
          };

          this.courseBannerMedia.push(fileData);

          // Update form control
          this.coursePostForm.get('course_banner_video')?.setValue(this.courseBannerMedia);
          this.coursePostForm.get('course_banner_video')?.markAsDirty();

          // Reset input
          input.value = '';
        },
        error: () => {
          this.toast.openSnackBar('Banner media upload failed');
        }
      });
    }
  }

  removeCourseBannerMedia(index: number): void {
    const updatedMedia = [...this.courseBannerMedia];
    updatedMedia.splice(index, 1);
    this.courseBannerMedia = updatedMedia;

    this.coursePostForm.get('course_banner_video')?.setValue(this.courseBannerMedia);
    this.coursePostForm.get('course_banner_video')?.markAsDirty();
    this.coursePostForm.get('course_banner_video')?.markAsTouched();
  }

  // Course Banner image logic

  courseBannerImage: { url: string; name: string; type: string; size: number }[] = [];

  uploadCourseBannerImage(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const files = Array.from(input.files);

    for (const file of files) {
      // Ensure file is an image
      if (!file.type.startsWith('image/')) {
        this.toast.openSnackBar('Only image files are allowed.');
        continue;
      }

      const formData = new FormData();
      formData.append('file', file);

      this.mediaService.uploadMedia(formData).subscribe({
        next: (res: any) => {
          const fileData = {
            url: res.url,
            name: file.name,
            type: file.type,
            size: file.size
          };

          this.courseBannerImage.push(fileData);

          // Update form control
          this.coursePostForm.get('course_banner_image')?.setValue(this.courseBannerImage);
          this.coursePostForm.get('course_banner_image')?.markAsDirty();

          // Reset input
          input.value = '';
        },
        error: () => {
          this.toast.openSnackBar('Banner image upload failed');
        }
      });
    }
  }

  removeCourseBannerImage(index: number): void {
    const updatedImages = [...this.courseBannerImage];
    updatedImages.splice(index, 1);
    this.courseBannerImage = updatedImages;

    this.coursePostForm.get('course_banner_image')?.setValue(this.courseBannerImage);
    this.coursePostForm.get('course_banner_image')?.markAsDirty();
    this.coursePostForm.get('course_banner_image')?.markAsTouched();
  }


  // Gallery logic

  galleryImages: { url: string; name: string; type: string; size: number }[] = [];

  uploadGalleryImages(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const files = Array.from(input.files);
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);

      this.mediaService.uploadMedia(formData).subscribe({
        next: (res: any) => {
          const imageData = {
            url: res.url,
            name: file.name,
            type: file.type,
            size: file.size
          };

          // Add to gallery image preview list
          this.galleryImages.push(imageData);

          // Update form control
          this.coursePostForm.get('course_gallery')?.setValue(this.galleryImages);
          this.coursePostForm.get('course_gallery')?.markAsDirty();

          // Clear file input
          input.value = '';
        },
        error: () => {
          this.toast.openSnackBar('Gallery image upload failed');
        }
      });
    }
  }

  removeGalleryImage(index: number): void {
    const updatedImages = [...this.galleryImages];
    updatedImages.splice(index, 1);
    this.galleryImages = updatedImages;

    this.coursePostForm.get('course_gallery')?.setValue(this.galleryImages);
    this.coursePostForm.get('course_gallery')?.markAsDirty();
    this.coursePostForm.get('course_gallery')?.markAsTouched();
  }




  // Open course preview dialog

  openCoursePreview(event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();


    this.dialog.open(CourseDetailsPreviewComponent, {
      width: '60%',
      panelClass: ['custom-modal'],
    
      data: {
        ...this.coursePostForm.value,
        eventDays: this.eventDays,
        sponsorImages: this.sponsorImages,
        presenterImage: this.presenterImageUrl,
        courseBannerMedia: this.courseBannerMedia,
        courseBannerImage: this.courseBannerImage,
        galleryImages: this.galleryImages,
        postPreview: true
      }

      
    });

  }

  today: Date = new Date();

  getEarlyBirdMaxDate(): Date | null {
    const start = this.coursePostForm.get('startDate')?.value;
    if (!start) return null;

    const date = new Date(start);
    date.setDate(date.getDate() - 1); // one day before start
    return date;
  }

  	allowOnlyCharacters(event: KeyboardEvent) {
		const char = event.key;
		if (!/^[a-zA-Z\s]*$/.test(char)) {
			event.preventDefault();
		}
	}
    allowOnlyNumbers(event: KeyboardEvent) {
    const char = event.key;
    if (!/^[0-9]$/.test(char)) {
      event.preventDefault();
    }
  }

}
